import React from 'react';

import JVCImage from '#/assets/images/jvcImage.png';
import RJCImage from '#/assets/images/rjcImage.png';
import {
    CityIcon,
    ContinentIcon,
    CountryIcon,
    IndustryIcon,
    RegionIcon,
    TypeIcon,
    NumberOfDoorsIcon,
    ZipCodeIcon,
} from '#/assets/svgs';
import { DetailItem, CompanySocialLinks } from '#/common/components';
import { Avatar, AvatarFallback, AvatarImage } from '#/components/ui';
import { capitalizeWords, getAddressByType, getValueByDataKey, ADDRESS_TYPES, NUMBER_OF_DOORS_KEY } from '#/utils';

const CompanyOverview = ({ data }) => {
    const {
        name,
        profilePicture,
        isRjcCompany,
        isJvcCompany,
        businessType,
        industry,
        description,
        socialLinks,
        addresses,
        data: metadata,
    } = data || {};

    const headquarterAddress = getAddressByType(addresses, ADDRESS_TYPES.HEADQUARTER);
    const { city, country, region, continent, zipCode } = headquarterAddress;
    const numberOfDoors = getValueByDataKey(metadata, NUMBER_OF_DOORS_KEY);

    return (
        <>
            <div className='flex flex-row gap-5'>
                <Avatar className='w-[70px] h-[70px] rounded-xl'>
                    <AvatarImage className='rounded-xl' src={profilePicture} alt={name} />
                    <AvatarFallback className='bg-gray-200 rounded-xl text-gray-500'>{name?.charAt(0)}</AvatarFallback>
                </Avatar>
                <div className='flex flex-col justify-center gap-3'>
                    <h3 className='font-cormorant text-2xl text-gray800 font-semibold'>{capitalizeWords(name)}</h3>
                    <div className='flex items-center gap-2'>
                        <CompanySocialLinks socialLinks={socialLinks} showAll />
                        {isJvcCompany && <img src={JVCImage} alt='JVC' className='w-[43px] h-[24px]' />}
                        {isRjcCompany && <img src={RJCImage} alt='RJC' className='w-[18px] h-[24px]' />}
                    </div>
                </div>
            </div>

            <div className='flex flex-row flex-wrap py-4 px-6 gap-y-6 justify-start rounded-xl border bg-gray50 mt-6'>
                {continent && <DetailItem icon={ContinentIcon} label='Continent' value={continent} />}
                {numberOfDoors && <DetailItem icon={NumberOfDoorsIcon} label='No. of Doors' value={numberOfDoors} />}
                {city && <DetailItem icon={CityIcon} label='City' value={city} />}
                {region && <DetailItem icon={RegionIcon} label='Region' value={region} />}
                {businessType && <DetailItem icon={TypeIcon} label='Type' value={businessType} />}
                {country && <DetailItem icon={CountryIcon} label='Country' value={country} />}
                {industry && <DetailItem icon={IndustryIcon} label='Industry' value={industry} />}
                {zipCode && <DetailItem icon={ZipCodeIcon} label='Zip Code' value={zipCode} />}
            </div>

            {description && <p className='font-inter text-base font-light text-gray700 mt-4'>{description}</p>}
        </>
    );
};

export { CompanyOverview };
